<div class="editor" *ngIf="form">

    <div class="editor-header">
        <div>
            <span class="eyebrow">RESSOURCENPLANUNG</span>
            <h2>{{ isEditing ? 'Termin bearbeiten' : 'Neuer Termin' }}</h2>
        </div>

        <button mat-icon-button (click)="closed.emit()" aria-label="Schließen">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="editor-content">

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Bezeichnung</mat-label>
            <input matInput [(ngModel)]="form.title" (ngModelChange)="showOverloadConfirmation = false"
                placeholder="z. B. Inbetriebnahme Anlage A">
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Kategorie</mat-label>
            <mat-select [ngModel]="form.categoryId" (ngModelChange)="onCategoryChanged($event)">
                <mat-option *ngFor="let category of categories" [value]="category.id">
                    {{ category.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>


        <h3>Zeitraum</h3>

        <div class="date-grid">

            <label>
                Beginn – Datum
                <input type="date" [(ngModel)]="form.startDate" (ngModelChange)="onDatesChanged()">
            </label>

            <label>
                Beginn – Uhrzeit
                <input type="time" [(ngModel)]="form.startTime" (ngModelChange)="resetTimeWarnings()">
            </label>

            <label>
                Ende – Datum
                <input type="date" [(ngModel)]="form.endDate" (ngModelChange)="onDatesChanged()">
            </label>

            <label>
                Ende – Uhrzeit
                <input type="time" [(ngModel)]="form.endTime" (ngModelChange)="resetTimeWarnings()">
            </label>

        </div>


        <h3>Mitarbeiter und Auslastung</h3>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Mitarbeiter auswählen</mat-label>
            <mat-select multiple [ngModel]="selectedEmployeeIds" (ngModelChange)="onEmployeesChanged($event)">

                <mat-option *ngFor="let employee of employees" [value]="employee.id">
                    {{ employee.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="participant-row" *ngFor="let employee of selectedEmployees">

            <div class="participant-name">
                <strong>{{ employee.name }}</strong>
                <span>{{ employee.weeklyHours }} h / Woche</span>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Auslastung %</mat-label>
                <input matInput type="number" min="0" max="100" [ngModel]="getPercent(employee.id)"
                    (ngModelChange)="setPercent(employee.id, $event)">
            </mat-form-field>
        </div>


        <h3>Zusätzliche Informationen</h3>

        <div class="date-grid">

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Kunde (optional)</mat-label>

                <mat-select [ngModel]="form.customerId" (ngModelChange)="onCustomerChanged($event)">

                    <mat-option [value]="null">Kein Kunde</mat-option>

                    <mat-option *ngFor="let customer of customers" [value]="customer.id">
                        {{ customer.name }}
                    </mat-option>

                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Anlage (optional)</mat-label>

                <mat-select [(ngModel)]="form.plantId" [disabled]="!form.customerId">

                    <mat-option [value]="null">Keine Anlage</mat-option>

                    <mat-option *ngFor="let plant of availablePlants" [value]="plant.id">
                        {{ plant.name }}
                    </mat-option>

                </mat-select>
            </mat-form-field>

        </div>

        <mat-form-field appearance="outline" class="full-width">
            <mat-label>Ort / Adresse (optional)</mat-label>

            <input matInput [(ngModel)]="form.location" placeholder="z. B. Industriepark 12, 4020 Linz">
        </mat-form-field>

        <div class="outlook-option" *ngIf="allowOutlookInvitation">
            <mat-checkbox [(ngModel)]="form.sendOutlookInvitation">
                Outlook-Termin an Mitarbeiter senden
            </mat-checkbox>

            <p class="hint">
                Wenn diese Option aktiviert ist, erhalten die ausgewählten
                Mitarbeiter eine Outlook-Kalendereinladung per E-Mail.
            </p>
        </div>


        <h3>Wochenendarbeit</h3>

        <p class="hint">
            Samstage und Sonntage werden standardmäßig nicht eingeplant.
            Du kannst einzelne Tage ausdrücklich hinzufügen.
        </p>

        <div *ngIf="weekendDates.length === 0" class="empty-weekend">
            Im gewählten Zeitraum liegt kein Wochenende.
        </div>

        <div class="weekend-card" *ngFor="let date of weekendDates">

            <mat-checkbox [checked]="isWeekendSelected(date)" (change)="toggleWeekend(date, $event.checked)">
                {{ formatDate(date) }}
            </mat-checkbox>

            <div class="weekend-hours" *ngIf="isWeekendSelected(date)">

                <div class="weekend-employee" *ngFor="let employee of selectedEmployees">

                    <span>{{ employee.name }}</span>

                    <mat-form-field appearance="outline">
                        <mat-label>Stunden</mat-label>
                        <input matInput type="number" min="0" max="24" [ngModel]="getWeekendHours(date, employee.id)"
                            (ngModelChange)="setWeekendHours(
                     date, employee.id, $event
                   )">
                    </mat-form-field>

                </div>
            </div>
        </div>

        <div class="error-message" *ngIf="errorMessage">
            <mat-icon>error_outline</mat-icon>
            {{ errorMessage }}
        </div>

        <div class="warning-message" *ngIf="showOverloadConfirmation">

            <strong>Überlastung erkannt</strong>
            <p>Folgende Überschreitungen wurden festgestellt:</p>

            <ul>
                <li *ngFor="let warning of overloadWarnings">
                    {{ warning }}
                </li>
            </ul>

            <p>Du kannst den Termin trotzdem speichern.</p>
        </div>

    </div>

    <div class="editor-footer">

        <button mat-button color="warn" *ngIf="isEditing" (click)="delete()" [disabled]="saving">
            Löschen
        </button>

        <span class="footer-spacer"></span>

        <button mat-button (click)="closed.emit()" [disabled]="saving">
            Abbrechen
        </button>

        <button mat-flat-button color="primary" (click)="save()" [disabled]="saving">
            {{ saving
            ? 'Wird gespeichert …'
            : (showOverloadConfirmation ? 'Trotzdem speichern' : 'Speichern') }}
        </button>

    </div>

</div>